import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-436d8414"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "dt-card__body mb-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Subscription Summary", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Plan:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Number of receivers:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total price:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "Credit Card", -1))
const _hoisted_10 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_11 = { class: "d-flex align-items-center my-2 summary_item-cc-item" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "summary__item-cc-icon",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M22 9v8a2 2 0 01-2 2H4a2 2 0 01-2-2V7a2 2 0 012-2h16a2 2 0 012 2v2zm0 0H6",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "summary__item-cc-number" }
const _hoisted_17 = { class: "summary__item-cc-number--last-four" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  class: "card-element",
  id: "card-element",
  ref: "card-element"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "Billing Address", -1))
const _hoisted_21 = { class: "row mb-sm-3" }
const _hoisted_22 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    onOpen: _ctx.loadCardElement,
    onClose: _ctx.onCancel
  }, {
    title: _withCtx(() => [
      (_ctx.isUpdate)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_1, "Update Payment Information"))
        : (_openBlock(), _createElementBlock("h2", _hoisted_2, "Start Ditto Subscription"))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_22, [
        _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isUpdate ? 'Update' : 'Submit'), 1)
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_loading, _ctx.isLoading]
        ])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        (!_ctx.isUpdate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_ctx.planName), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.receiverCount), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_8,
                  _createTextVNode(" $" + _toDisplayString(_ctx.totalPrice), 1)
                ])
              ]),
              _createVNode(_component_el_divider)
            ]))
          : _createCommentVNode("", true),
        (_ctx.customer && _ctx.customer.shipping)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              ref: "form",
              "label-position": "top",
              rules: _ctx.customerRules,
              model: _ctx.customer
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                (_ctx.card)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        (_ctx.cardBrand === 'visa' || _ctx.cardBrand === 'mastercard')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "summary__item-cc-image",
                              src: require('../../assets/images/' + _ctx.cardBrand + 'Logo.png')
                            }, null, 8, _hoisted_12))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_15)),
                        _createElementVNode("span", _hoisted_16, [
                          _createTextVNode("●●●● ●●●● ●●●● "),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.card.last4), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_checkbox, {
                          modelValue: _ctx.useNewCard,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.useNewCard) = $event)),
                          label: "Use a new card",
                          size: "large"
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.useNewCard || !_ctx.card)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, null, 512)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_divider),
                _hoisted_20,
                _createVNode(_component_el_form_item, {
                  prop: "name",
                  label: "Name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.customer.shipping.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customer.shipping.name) = $event)),
                      placeholder: "Name"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  prop: "line1",
                  label: "Address 1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.customer.shipping.address.line1,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customer.shipping.address.line1) = $event)),
                      placeholder: "Address 1"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  prop: "address2",
                  label: "Address 2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.customer.shipping.address.line2,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customer.shipping.address.line2) = $event)),
                      placeholder: "Address 2"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  prop: "city",
                  label: "City"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.customer.shipping.address.city,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customer.shipping.address.city) = $event)),
                      placeholder: "City"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_el_form_item, {
                    class: "col-sm-6 p-0 pe-sm-2 mb-3 mb-sm-0",
                    prop: "state",
                    label: "State"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.customer.shipping.address.state,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customer.shipping.address.state) = $event)),
                        placeholder: "State"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    class: "col-sm-6 p-0 ps-sm-3 mb-3 mb-sm-0",
                    prop: "postal_code",
                    label: "Postal Code"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.customer.shipping.address.postal_code,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.customer.shipping.address.postal_code) = $event)),
                        placeholder: "Zip/Postal Code"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_el_form_item, {
                  prop: "country",
                  label: "Country"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.customer.shipping.address.country,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customer.shipping.address.country) = $event)),
                      placeholder: "Country"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  class: "mb-0",
                  prop: "vatNumber",
                  label: "VAT Number"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.customer.vat_number,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.customer.vat_number) = $event)),
                      placeholder: "VAT Number"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["rules", "model"]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.isLoading]
      ])
    ]),
    _: 1
  }, 8, ["onOpen", "onClose"]))
}